module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/close blue icon-e660caf5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/close blue icon.svg
// module id = ./app/web/src/assets/close blue icon.svg
// module chunks = 0